module.exports = __webpack_public_path__ + "img/kma_gallery4.e3824205.jpg";